import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { RegionManagementComponent } from './region-management.component';
import { OrphanMunicipalityDialogComponent } from './dialog/orphan-municipality-dialog/orphan-municipality-dialog.component';
import { OrphanMunicipalityComponent } from './components/orphan-municipality/orphan-municipality.component';
import { ReassignKamDialogComponent } from './dialog/reassign-kam-dialog/reassign-kam-dialog.component';
import { ReassignmentDialogComponent } from './dialog/reassignment-dialog/reassignment-dialog.component';
import { AddEditRegionDialogComponent } from './dialog/add-edit-region-dialog/add-edit-region-dialog.component';

@NgModule({
  declarations: [
    RegionManagementComponent,
    OrphanMunicipalityComponent,
    OrphanMunicipalityDialogComponent,
    ReassignKamDialogComponent,
    ReassignmentDialogComponent,
    AddEditRegionDialogComponent,
  ],
  imports: [CommonModule, SharedModule],
})
export class RegionManagementModule {}
